<template>
    <header class="nav-content">
        <!-- <img class="logo" :class="{ 'is-hidden': hideLogo }" src="@/assets/images/logo.png" alt=""> -->
        <div class="nav-box">
            <!-- @select="handleSelect" -->
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
                <el-menu-item @click="scrollto('index')" index="1" key="1">首页</el-menu-item>
                <!-- <el-menu-item @click="scrollto('news')" key="2">雅亘新闻</el-menu-item>
                <el-menu-item @click="scrollto('experts')" key="3">专家学术</el-menu-item> -->
                <!-- 新增菜单 -->

                <el-submenu index="6" key="6">
                    <template slot="title">科技新生</template>
                    <el-menu-item @click="routerTo('source')" index="d-2" key="d-2">朔源·雅亘</el-menu-item>
                    <!-- <el-menu-item @click="scrollToPage('d-1')" index="d-1" key="d-1">印记·见证</el-menu-item> -->
                    <el-menu-item index="d-122" key="d-122" @click="routerTo('craftsmanship')">匠心·制造</el-menu-item>
                    <el-menu-item index="d-3" key="d-3" @click="routerTo('missionValues')">心源·远景</el-menu-item>
                    <el-menu-item index="d-4" key="d-4" @click="routerTo('corporateBrochure')">雅亘知行</el-menu-item>
                  
                </el-submenu>

                <el-submenu index="7" key="7">
                    <template slot="title">科学精粹</template>
                    <el-menu-item index="d-5" key="d-5" @click="routerTo('leading')">领先优势</el-menu-item>
                    <el-menu-item index="d-6" key="d-6" @click="handleNewTea">荼道新译</el-menu-item>
                    <el-menu-item index="d-7" key="d-7" @click="routerTo('great')">臻选佳品</el-menu-item>
                </el-submenu>

                <el-menu-item index="8" key="8" @click="routerTo('joinUs')">共荣·同行</el-menu-item>

                <el-submenu index="9" key="9">
                    <template slot="title">社会责任</template>
                    <el-menu-item index="d-9" key="d-9" @click="routerTo('culturalProtection')">文化守护</el-menu-item>
                    <el-menu-item index="d-10" key="d-10" @click="routerTo('greenEcology')">绿色生态</el-menu-item>
                    <el-menu-item index="d-11" key="d-11" @click="routerTo('humanisticCare')">人文关怀</el-menu-item>
                </el-submenu>

                <!-- <el-menu-item key="10">新闻</el-menu-item> -->
            </el-menu>
        </div>
    </header>
</template>
<script>
export default {
    components: {

    },
    data() {
        return {
            activeIndex: '1',
            hideLogo: false,
            hideThreshold: 120,
            showThreshold: 40,
            scrollRafId: null
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.handleScroll();
    },
    beforeDestroy() {
        if (this.scrollRafId) {
            cancelAnimationFrame(this.scrollRafId);
            this.scrollRafId = null;
        }
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            if (this.scrollRafId) return;
            this.scrollRafId = requestAnimationFrame(() => {
                const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
                if (!this.hideLogo && scrollTop > this.hideThreshold) {
                    this.hideLogo = true;
                } else if (this.hideLogo && scrollTop < this.showThreshold) {
                    this.hideLogo = false;
                }
                this.scrollRafId = null;
            });
        },
        scrollto(id) {
            if (window.location.pathname !== '/') {
                this.$router.push('/');
                return;
            }
            const dom = document.getElementById(id)
            window.scrollTo({
                top: dom.offsetTop,
                behavior: 'smooth'
            });
        },
        scrollToPage(id) {
            this.$router.push({
                path: '/dav',
                query: { id }
            });
        },
        handleNewTea() {
            this.$router.push({
                path: '/new-tea',
            });
        },
        handleSource() {
            this.$router.push({
                path: '/source',
            });
        },
        routerTo(path) {
            this.$router.push({
                path: path,
            });
        }
    }
};
</script>
<style lang="less" >
   

.nav-content {
    width: 100%;
    background: #33402f;
    padding: 0 32px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    box-sizing: border-box;
    .logo {
        width: 60px;
        margin-bottom: 12px;
        max-height: 60px;
        transition: opacity .2s ease, max-height .2s ease, margin-bottom .2s ease;
        &.is-hidden {
            opacity: 0;
            max-height: 0;
            margin-bottom: 0;
        }
    }

    .nav-box {
        width: 100%;
        display: flex;
        justify-content: center;
        .el-menu.el-menu--horizontal {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            background: #fff;
            border-bottom: 0 none;
            &:not(.el-menu--collapse) {
                width: auto;
            }
            .el-menu-item {
                color: #fff !important;
                font-size: 15px;
                padding: 0 18px;
                border-bottom: 0 none !important;
                background: #33402f !important;
            }
            .el-menu-item:hover {
                color: #fff !important;
            }
            .el-menu-item:hover,
            .el-menu-item.is-active {
                background: #33402f !important;
                border-bottom: 0 none !important;
            }
            .el-submenu {
                .el-submenu__title {
                    color: #fff !important;
                    font-size: 15px;
                    padding: 0 18px;
                    border-bottom: 0 none !important;
                    height: 60px;
                    line-height: 60px;
                }
                .el-submenu__title:hover {
                    color: #fff !important;
                    background: #33402f !important;
                }
                .el-submenu__icon-arrow {
                    color: #fff !important;
                }
            }
            .el-submenu .el-menu-item {
                min-width: 240px;
                font-size: 14px;
                color: #333 !important;
                background: #33402f !important;
            }
            .el-submenu .el-menu-item:hover {
                color: var(--theme_font_color) !important;
                background: #f5f7fa !important;

            }
        }
    }
}
</style>